import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Message } from 'semantic-ui-react';
import _ from 'lodash';
import axios from 'axios';

const EMBED_API = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/influencer/instagram/embed';

const imgStyle = { margin: '0px auto' };
const width100 = { width: '100%' };

const instagramStyle = {
  height: '300px',
  minHeight: '300px',
  width: '300px',
  objectFit: 'cover',
  display: 'block',
  margin: '0px auto',
};

const getStyle = (useInstagramStyle, maxWidth) => {
  if (useInstagramStyle) return instagramStyle;
  if (maxWidth) return width100;
  return imgStyle;
};

class DyzioInstagramEmbed extends Component {
  constructor() {
    super();
    this.state = {
      savedThumbnailUrl: '',
      error: false,
      loading: true,
    };
  }

  async componentDidMount() {
    const { assetId } = this.props;
    try {
      const { status, data } = await axios(`${EMBED_API}/${assetId}/data`);

      if (_.isEqual(status, 200)) {
        const { savedThumbnailUrl } = _.get(data, 'data');
        this.setState({
          savedThumbnailUrl,
          loading: false,
        });
      } else {
        this.setState({
          error: true,
          loading: false,
        });
      }
    } catch (e) {
      this.setState({
        error: true,
        loading: false,
      });
    }
  }

  render() {
    const { savedThumbnailUrl,
      error,
      loading,
    } = this.state;
    const { maxWidth, useInstagramStyle } = this.props;

    const derivedStyle = getStyle(useInstagramStyle, maxWidth);

    if (error) {
      return (
        <Message
          header="Error Fetching Asset"
          content="Please check the url and retry."
        />
      );
    }

    if (loading) {
      return (
        <Message
          header="Loading Asset"
        />
      );
    }

    if (savedThumbnailUrl) {
      return (
        <Image
          size="large"
          style={derivedStyle}
          src={savedThumbnailUrl}
        />
      );
    }

    return (
      <Message
        header="Error Fetching Asset"
        content="Please check the url and retry."
      />
    );
  }
}

DyzioInstagramEmbed.propTypes = {
  assetId: PropTypes.string.isRequired,
  useInstagramStyle: PropTypes.string,
  maxWidth: PropTypes.string,
};

DyzioInstagramEmbed.defaultProps = {
  maxWidth: false,
  useInstagramStyle: false,
};

export default DyzioInstagramEmbed;



// WEBPACK FOOTER //
// ./src/containers/summary/components/dyzio-instagram-embed/index.js